module.exports = __webpack_public_path__ + "static/media/bg.c5df100a.png";